import Vue from 'vue';
import { gsap } from 'gsap/all';

Vue.component('jobs-list-component', {
    data() {
        return {
            jobs: [],
            length: 4,
        };
    },

    props: {
        initialJobs: {
            type: Array,
            default: [],
        },
    },

    computed: {
        loadedJobs() {
            return this.initialJobs.slice(0, this.length);
        },
    },

    methods: {
        loadMore() {
            if (this.length > this.initialJobs.length) return;

            this.length += 4;
        },

        onBeforeEnter(el) {
            gsap.set(el, {
                autoAlpha: 0,
                y: 20,
            });
        },

        onEnter(el, done) {
            gsap.to(el, {
                autoAlpha: 1,
                y: 0,
                delay: el.dataset.index * 0.15,
                onComplete: done,
            });
        },

        onLeave(el, done) {
            gsap.to(el, {
                autoAlpha: 0,
                y: 20,
                delay: el.dataset.index * 0.15,
                onComplete: done,
            });
        },
    },
});
